import * as React from "react";
const SvgTitleOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M5 4v3h5.5v12h3V7H19V4H5z" />
  </svg>
);
export default SvgTitleOutlined;
